import Vue from 'vue';

Vue.filter('toFixed', function (value, arg) {
	return value.toFixed(arg);
});